import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { EVENT_TEMPLATES_FORM } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const venueTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return reducers.dataTable.tableFetchReducer(
        EVENT_TEMPLATES_FORM,
        state,
        action
      )
  }
}

export default combineReducers({
  data: venueTemplatesReducer,
  tableInfo: tableReducer,
})
